
export const CDN_ROOT = "https://cdn.builtwithscience.com";
